export enum JURISDICTIONS_SELECT_VALUE_KEYS {
  ID = 'id',
  SHORT_NAME = 'shortName'
}
